<script>
import ContentTree from '@/components/lessons/ContentTree.vue';
export default { name: 'CourseContentBrowser', components: { ContentTree }, props: { courseId: [String, Number], academicYearId: [String, Number] } };
</script>
<template><ContentTree :course-id="courseId" :academic-year-id="academicYearId" /></template>
